:host {
  display: block;
  @apply w-full;
}
